/**
 * Returns whether a Polaris feature applies to the form: its landing page
 * listed the feature flag, or the form is switched to Polaris in Capture.
 * A listed flag can only add a feature; it cannot turn one off.
 *
 * @param {object} store - The redux state
 * @param {string} feature - The feature flag name, e.g. 'enableResultsPage'
 * @returns {boolean}
 */
const selectIsPolarisFeatureEnabled = (store, feature) =>
  Boolean(store.features?.[feature]) ||
  Boolean(store.formConfig?.isPolarisForm);

export default selectIsPolarisFeatureEnabled;
